export default __webpack_public_path__ + "static/media/avatar.09a29111.png";